import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  useTranslator,
  InputCheckboxControlled as InputCheckbox,
} from '@front-activerse/common-components';
import { useParams } from 'react-router-dom';
import { Container, Row, Col, Button } from 'reactstrap';
import Layout from '../Layout/Layout';
import Loader from '../Layout/Loader';
import RemoveAccountError from './Components/RemoveAccountError';
import TokenExpiredError from './Components/TokenExpiredError';
import SuccessView from './Components/SuccessView';
import TitleBar from '../Layout/TitleBar';

const RemoveAccountContainer = ({ loading, removeUserAccount }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [isError, setIsError] = useState(false);
  const [tokenExpired, setIsTokenExpired] = useState(false);
  const [success, setSuccess] = useState(false);
  const { token } = useParams();
  const { t } = useTranslator();

  const handleConfirmRemoveAccount = async () => {
    try {
      const response = await removeUserAccount({ variables: { token } });
      if (response.data.removeAccount.confirm.__typename === 'ValidationException') {
        setIsTokenExpired(true);
      } else if (response.data.removeAccount.confirm.__typename === 'UnauthorizedException') {
        setIsError(true);
      } else {
        setSuccess(true);
      }
    } catch (err) {
      setIsError(true);
    }
  };

  const renderNextView = () => {
    if (isError) {
      return <RemoveAccountError handleConfirmRemoveAccount={handleConfirmRemoveAccount} />;
    }
    if (tokenExpired) {
      return <TokenExpiredError />;
    }
    return <SuccessView />;
  };

  return (
    <Layout simpleLayout>
      <TitleBar showBackBtn={false}>{t('deletingAccount.navbarTitle')}</TitleBar>
      <section className="page-template-remove-account full-height7">
        <Container>
          <Row>
            <Col xs="12" md={{ size: 6, offset: 3 }}>
              <div className="content-container">
                {!isError && !tokenExpired && !success ? (
                  <div className="white-box">
                    <p className="semi-bold">{t('deletingAccount.afterDeletionTitle')}</p>
                    <ul>
                      <li>{t('deletingAccount.afterDeletion.noLoginAccess')}</li>
                      <li>{t('deletingAccount.afterDeletion.loseProgress')}</li>
                      <li>{t('deletingAccount.afterDeletion.dataDeleted')}</li>
                    </ul>

                    <div className="mb-xl">
                      <InputCheckbox
                        label={t('deletingAccount.confirmationCheckboxInfo')}
                        id="acceptConditions"
                        name="showOnlyCurrentDiet"
                        value={isChecked}
                        handleChange={() => setIsChecked(!isChecked)}
                        checked={isChecked}
                        large
                      />
                    </div>

                    <Button
                      color="primary"
                      disabled={!isChecked}
                      className="w-100"
                      onClick={handleConfirmRemoveAccount}
                    >
                      {t('deletingAccount.afterDelation.deleteAccount.button')}
                    </Button>
                  </div>
                ) : (
                  renderNextView()
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {loading ? <Loader fixed="no" /> : ''}
    </Layout>
  );
};

RemoveAccountContainer.propTypes = {
  loading: PropTypes.bool.isRequired,
  removeUserAccount: PropTypes.func.isRequired,
};

export default RemoveAccountContainer;
